import { Injectable } from '@angular/core';
import { MaintenanceService } from './maintenance.service';
import { ApplicationStateService } from './application-state.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInitializationService {
  constructor(
    private maintenanceService: MaintenanceService,
    private appState: ApplicationStateService
  ) {}

  async init(): Promise<void> {
    try {
      // Step 1: Fetch Maintenance Status
      await this.maintenanceService.checkMaintenanceStatus();

      // Step 2: Other initialization logic can go here

      this.appState.setInitialized(true);
    } catch (error) {
      console.error('Application Initialization Failed:', error);
      this.appState.setError(error);
      // We don't rethrow here because we want the app to start
      // but AppComponent will handle the error state by showing 500 page.
    }
  }
}
